var a = (t, s, r) => new Promise((c, o) => {
  var i = (e) => {
    try {
      n(r.next(e));
    } catch (u) {
      o(u);
    }
  }, y = (e) => {
    try {
      n(r.throw(e));
    } catch (u) {
      o(u);
    }
  }, n = (e) => e.done ? c(e.value) : Promise.resolve(e.value).then(i, y);
  n((r = r.apply(t, s)).next());
});
import { u as m, a as f } from "./query-client-DZ5Df1It.js";
import { r as l } from "./define-element-XpjsV6s1.js";
function Q(t) {
  return m(), f({
    queryKey: ["content", t],
    queryFn: () => a(null, null, function* () {
      return yield l(`cart/content/${t}`);
    })
  });
}
export {
  Q as u
};
